'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var pageTransitions = function pageTransitions() {
  function transition() {
    if (!window.AnimationEvent) {
      return;
    }
    var transition = document.getElementById('transition');
    transition.classList.add('fade-out');
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (!window.AnimationEvent) {
      return;
    }

    var anchors = document.querySelectorAll('a:not(.js-tablist__link):not(.smooth):not(.form-toggle)');

    for (var idx = 0; idx < anchors.length; idx += 1) {
      if (anchors[idx].hostname !== window.location.hostname) {
        continue;
      }

      anchors[idx].addEventListener('click', function (event) {
        var transition = document.getElementById('transition'),
            anchor = event.currentTarget;

        var listener = function listener() {
          window.location = anchor.href;
          transition.removeEventListener('animationend', listener);
        };
        transition.addEventListener('animationend', listener);

        event.preventDefault();
        transition.classList.add('fade-in');
      });
    }
  });

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) {
      return;
    }
    var transition = document.getElementById('transition');
    transition.classList.remove('fade-in');
  });

  transition();
};

exports.default = pageTransitions;